import { useBusinessQuery } from '../../../../api/businesses';
import { useBusinessKycTokenQuery } from '../../../../api/kyc';
import { BusinessNameStep } from './KybNameStep';
import { SumSubStep } from './SumSubStep';

export function BusinessVerificationStep({ onSuccess }: { onSuccess?: () => void }) {
  const businessQuery = useBusinessQuery();
  const tokenQuery = useBusinessKycTokenQuery();

  const profile = businessQuery.data?.profile;
  if (!profile) {
    return null;
  }

  if (!profile.name) {
    return <BusinessNameStep />;
  }

  return <SumSubStep tokenQuery={tokenQuery} onSuccess={onSuccess} />;
}
